// services/subscriptionService.ts 
import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3944";

export interface PaymentSubscription {
  id: number;
  merchant_code: string;
  institution_code: string | null;
  method_code: 'card' | 'mobile_money';
  status: 'pending' | 'active' | 'suspended' | 'rejected';
  created_at: string | null;
  updated_at: string | null;
}

export interface ActiveMethodsResponse {
  active_methods: ('card' | 'mobile_money')[];
  has_card: boolean;
  has_mobile_money: boolean;
}

export const subscriptionService = {
  // Vérification simple de l'abonnement carte
  async hasCardSubscription(): Promise<boolean> {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/merchants/check-card-subscription`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data.has_card_subscription;
    } catch (error) {
      console.error("Error checking card subscription:", error);
      return false;
    }
  },

  // Récupérer tous les abonnements
  async getMerchantSubscriptions(): Promise<PaymentSubscription[]> {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/merchants/payment-subscriptions`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching merchant subscriptions:", error);
      return [];
    }
  },

  // Récupérer les méthodes de paiement actives
  async getActivePaymentMethods(): Promise<ActiveMethodsResponse> {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/merchants/active-payment-methods`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching active payment methods:", error);
      return {
        active_methods: [],
        has_card: false,
        has_mobile_money: false
      };
    }
  },

  // Vérifier si le merchant a accès au mobile money
  async hasMobileMoneyAccess(): Promise<boolean> {
    try {
      const methods = await this.getActivePaymentMethods();
      return methods.has_mobile_money;
    } catch (error) {
      console.error("Error checking mobile money access:", error);
      return false;
    }
  }
};